import React, { useState } from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import Button from "@material-ui/core/Button"
import Hidden from "@material-ui/core/Hidden"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import styled from "styled-components"
import WrapTypo from "../components/WrapTypo"

import TopView from "./topView"
import SpIntroduction from "./spIntroduction"
import SpProduct from "./spProduct"
import SpUnfilterTime from "./spUnfilterTime"
import Point from "./point"
import News from "./news"
import Campaign from "./campaign"

function SpTopContent() {
  return (
    <>
      <Box pt={"69px"}>
        <TopView />
        <Box data-aos="fade-in" data-aos-duration="1000">
          <SpIntroduction />
        </Box>
        <Box data-aos="fade-in" data-aos-duration="1000">
          <SpProduct />
        </Box>
        <Box data-aos="fade-in" data-aos-duration="1000">
          <Point />
        </Box>
        <Box data-aos="fade-in" data-aos-duration="1000">
          <SpUnfilterTime />
        </Box>

        <Box>
          <News />
        </Box>
        <Box>
          <Campaign />
        </Box>
      </Box>
    </>
  )
}

export default SpTopContent
